module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-on-center close-picker",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page"
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.onRefresh(false)
      }
    }
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.inboxMessages)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content infinite-scroll",
    staticStyle: {
      "z-index": "9"
    },
    on: {
      "infinite": _vm.onInfinite
    }
  }, [_vm._m(0), _vm._v(" "), _c('page-nav-bar', {
    attrs: {
      "currentServiceName": _vm.serviceName,
      "popoverName": ".popoverInbox",
      "subNavTitle": _vm.$t('common.received_reqsts'),
      "menuAccess": true,
      "paymentsNumber": _vm.paymentsNumber
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage showLargeScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('button', {
    staticClass: "milkyBlock boxRequest pull-right",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.inboxMessages)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.extract_csv')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "searchForm"
  }, [_c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": true,
      "received": true
    }
  }), _vm._v(" "), _c('transactions-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "inMessages": _vm.inboxMessages
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-to-refresh-layer"
  }, [_c('div', {
    staticClass: "preloader"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-to-refresh-arrow"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36e80517", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e80517","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/payments/CMInboxPage.vue
// module id = 1653
// module chunks = 2